module.exports = __webpack_public_path__ + "static/media/sneha.24529b20.png";